import React from 'react'
import { Button, useNotify } from 'react-admin'
import { Form } from 'react-final-form'
import { makeStyles, Paper, Typography, Checkbox } from '@material-ui/core'
import { get } from 'lodash'

import { ResourceSelector } from 'components'
import { FetcherClient } from 'services/fetcher'

const useStyles = makeStyles({
  paperContainer: {
    padding: 16,
  },
})

interface ItemsProps {
  type: string
  slug?: string
}

export const CacheControl: React.FC = () => {
  const classes = useStyles()
  const notify = useNotify()

  const [clearHome, setClearHome] = React.useState(false)
  const [clearAlgolia, setClearAlgolia] = React.useState(false)
  const [clearCourse, setClearCourse] = React.useState<string>('')
  const [clearLesson, setClearLesson] = React.useState<string>('')

  const onSubmit = async (values: Array<ItemsProps> = []) => {
    if (!clearHome && !clearAlgolia && !clearCourse && !clearLesson) return

    if (!values.length) values = []
    if (clearHome) values.push({ type: 'home' })
    if (clearCourse)
      values.push({
        type: 'course',
        slug: clearCourse,
      })
    if (clearLesson)
      values.push({
        type: 'lesson',
        slug: clearLesson,
      })

    let response

    if (values.length > 0) {
      response = await FetcherClient(`/cms/caches`, {
        method: 'POST',
        data: JSON.stringify({ cache: values }),
      })
    }

    if (clearAlgolia) {
      response = await FetcherClient(`/algolia/seed`, {
        method: 'GET',
        timeout: 180000,
      })
    }

    if (response && get(response, 'status', '') === 200) {
      setClearHome(false)
      setClearCourse('')
      setClearLesson('')
      setClearAlgolia(false)
      return notify('post_successfully')
    }

    return notify('post_failed', 'warning')
  }

  return (
    <Paper className={classes.paperContainer}>
      <Typography variant="h5" color="textSecondary" gutterBottom>
        Caches
      </Typography>
      <Form onSubmit={() => {}}>
        {(props) => (
          <form onSubmit={props.handleSubmit}>
            <Checkbox
              color="primary"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
              onChange={() => setClearHome(!clearHome)}
            />
            <Typography variant="caption" color="textSecondary" gutterBottom>
              Marque para limpar cache da Home
            </Typography>

            <Checkbox
              color="primary"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
              onChange={() => setClearAlgolia(!clearAlgolia)}
            />
            <Typography variant="caption" color="textSecondary" gutterBottom>
              Marque para limpar cache da busca
            </Typography>

            <hr />

            <Typography variant="caption" color="textSecondary" gutterBottom>
              Para: limpar o cache de séries e cursos pelo slug
            </Typography>
            <ResourceSelector
              fullWidth
              label="Curso/Série"
              resource="cms/grouper/courses"
              source="course"
              optionValue="slug"
              onChange={(value: any) => setClearCourse(value)}
            />

            <Typography variant="caption" color="textSecondary" gutterBottom>
              Para: limpar cache de aulas pelo slug
            </Typography>
            <ResourceSelector
              fullWidth
              label="Aula"
              resource="cms/grouper/lesson"
              source="lesson"
              optionValue="slug"
              onChange={(value: any) => setClearLesson(value)}
            />

            <Button
              type="submit"
              variant="contained"
              label="limpar cache"
              submitOnEnter={false}
              onClick={() => onSubmit()}
            />
          </form>
        )}
      </Form>
    </Paper>
  )
}
